import { UseQueryResult } from '@tanstack/react-query'
import { getRewardShoppingPointBalance } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

export interface RewardShoppingAmountResponse {
  availableAmount: number | null
}

interface Props {
  useErrorBoundary?: boolean
  enabled?: boolean
}

function useGetRewardShoppingAmount(props?: Props): UseQueryResult<RewardShoppingAmountResponse, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<RewardShoppingAmountResponse, AxiosError>(
    KEYS.REWARD_SHOPPING_AMOUNT(),
    async () => {
      if (storageMock) {
        const response = await mockHost.get<{ data: RewardShoppingAmountResponse }>('/api/v1/points/balance')
        return {
          availableAmount: response.data.data?.availableAmount ?? null,
        }
      }
      const response = await getRewardShoppingPointBalance()
      return {
        availableAmount: response.data.data?.availableAmount ?? null,
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? false,
      enabled: props?.enabled,
    }
  )
}

export { useGetRewardShoppingAmount }
